import { useForm } from 'react-hook-form'

export type ChatMessageFormData = { message: string }

export function useChatMessageForm() {
  return useForm<ChatMessageFormData>({ defaultValues: { message: '' } })
}
